<div class="user-menu">
  <app-avatar
    [firstName]="userProfile?.first_name"
    [lastName]="userProfile?.last_name"
    [imageUrl]="userProfile?.image"
    size="medium"
  />

  <span class="user-menu__name" data-typography="bodyLarge">
    {{ userProfile?.first_name }} {{ userProfile?.last_name }}
  </span>

  <span class="user-menu__email" data-typography="bodySmall">
    {{ userProfile?.email }}
  </span>

  <app-divider class="user-menu__divider" thickness="thin" color="light" />

  <button class="user-menu__logout" (click)="onLogout()">
    <mat-icon>logout</mat-icon>
    <span data-typography="labelLarge">Выйти</span>
  </button>
</div>
